import { getFromApi } from "../utils/request";
import { ApiResponse } from "../utils/response";

export interface Product {
  id: string;
  name: string;
  volume: number;
  // TODO remove optionality after id is available
  distributorId?: number;
  distributor: string;
  price: number;
  gtin: number;
  abv: number;
  vintage: number | null;
  agentName: string;
}

export const findProductByNumber = async (productId: string): Promise<Product> => {
  try {
    const paddedProductId = productId.padStart(6, "0");
    const { data } = await getFromApi<Product>(`/v1/product/${paddedProductId}`);
    return data;
  } catch (e) {
    throw new Error(e.message);
  }
};

export const findProducts = async (query: string): Promise<ApiResponse<Product[]>> => {
  try {
    if (/^[0-9]+$/.test(query)) {
      // using product id, return single value in array
      const product = await findProductByNumber(query);
      return { data: product ? [product] : [] };
    }

    const data = await getFromApi<Product[]>(`/v1/products`, { q: query });
    return data;
  } catch (e) {
    console.error(e);
    return { data: [] };
  }
};
